import React, { useState } from 'react'
import PropTypes from "prop-types";
import { Link, useLocation, useParams } from 'react-router-dom';
import { Alert, Card, CardBody, Col, Container, FormFeedback, Input, Label, Row } from 'reactstrap';
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from 'react-toastify';
import Loader from 'components/Loader/Loader';
import lmsLogo from "../../assets/images/lmsLogo.png";
import withRouter from 'components/Common/withRouter';
import { resetPassword } from 'helpers/user_helper';

const ResetPassword = (props) => {
    document.title = "Reset Password | LMS - Skill Serve";

    // If your API requires a token (like /reset-password/:token), extract it from params
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    const [loader, setLoader] = useState(false);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            password: '',
            confirmPassword: '',
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .required("Please enter your new password")
                .min(6, "Password must be at least 6 characters"),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref("password"), null], "Passwords must match")
                .required("Please confirm your password"),
        }),
        onSubmit: (values) => {
            handleSubmit(values);
        }
    });

    const handleSubmit = async (values) => {
        try {
            setLoader(true);
            const res = await resetPassword({ token, newPassword: values.password });

            if (res?.success) {
                toast.success(res?.message || "Password reset successful!");
                props.router.navigate("/login"); // redirect to login
            } else {
                toast.error(res?.message || "Password reset failed");
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    };

    return (
        <React.Fragment>
            <div className="account-pages my-5 pt-sm-5">
                {loader && <Loader />}
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="overflow-hidden">
                                <CardBody className="pt-0">
                                    <h3 className="text-center mt-5 mb-2">
                                        <Link to="/" className="d-block auth-logo">
                                            <img src={lmsLogo} alt="" height="80" className="auth-logo-dark" />
                                        </Link>
                                    </h3>
                                    <div className="p-3">
                                        <h4 className="text-muted font-size-18 mb-3 text-center">Set New Password</h4>

                                        <form className="form-horizontal mt-4"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            {/* Password */}
                                            <div className="mb-3">
                                                <Label htmlFor="password">New Password</Label>
                                                <Input
                                                    name="password"
                                                    type="password"
                                                    placeholder="Enter new password"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.password || ""}
                                                    invalid={
                                                        validation.touched.password && validation.errors.password ? true : false
                                                    }
                                                />
                                                {validation.touched.password && validation.errors.password && (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.password}
                                                    </FormFeedback>
                                                )}
                                            </div>

                                            {/* Confirm Password */}
                                            <div className="mb-3">
                                                <Label htmlFor="confirmPassword">Confirm Password</Label>
                                                <Input
                                                    name="confirmPassword"
                                                    type="password"
                                                    placeholder="Confirm password"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.confirmPassword || ""}
                                                    invalid={
                                                        validation.touched.confirmPassword && validation.errors.confirmPassword
                                                            ? true : false
                                                    }
                                                />
                                                {validation.touched.confirmPassword && validation.errors.confirmPassword && (
                                                    <FormFeedback type="invalid">
                                                        {validation.errors.confirmPassword}
                                                    </FormFeedback>
                                                )}
                                            </div>

                                            <Row className="mb-3">
                                                <div className="col-12 text-end">
                                                    <button
                                                        className="btn btn-primary w-md waves-effect waves-light"
                                                        type="submit"
                                                    >
                                                        Reset Password
                                                    </button>
                                                </div>
                                            </Row>
                                        </form>
                                    </div>
                                </CardBody>
                            </Card>
                            <div className="mt-5 text-center">
                                <p>
                                    Remember your password?{" "}
                                    <Link to="/login" className="text-primary">Sign In</Link>
                                </p>
                                © {new Date().getFullYear()} SS <span className="d-none d-sm-inline-block"> - Created By Amass Skill Ventures</span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

ResetPassword.propTypes = {
    history: PropTypes.object,
};

export default withRouter(ResetPassword);
